import { ReactNode } from "react";
import AccountInfoStep from "./AccountInfoStep";
import CompanyInfoStep from "./CompanyInfoStep";

interface FormStepRendererProps {
  currentStep: number;
  formData: {
    email: string;
    name: string;
    password: string;
    confirmPassword: string;
    phone: string;
    documentType: "cpf" | "cnpj";
    document: string;
    subdomain: string;
  };
  handleChange: (field: string, value: string) => void;
}

export const FormStepRenderer = ({
  currentStep,
  formData,
  handleChange,
}: FormStepRendererProps): ReactNode => {
  switch (currentStep) {
    case 1:
      return <AccountInfoStep formData={formData} handleChange={handleChange} />;
    case 2:
      return <CompanyInfoStep formData={formData} handleChange={handleChange} />;
    default:
      return <AccountInfoStep formData={formData} handleChange={handleChange} />;
  }
};
